import React from 'react'
import { RestaurantInfo } from '../../api/restaurant/getRestaurant'
import { CreditCardFormWithSpi } from './CreditCardFormWithSpi'
import { CreditCardFormIframe } from './CreditCardFormIframe'
import { useCreditCardForm } from './CreditCardFormProvider'
import { Currency } from '@toasttab/buffet-pui-country-utilities'
import { useBanquetProps, useSentry } from 'banquet-runtime-modules'

export type PaymentSuccessEvent = (props: {
  amount: number
  currency: Currency
  paymentProvider: 'SPI' | 'IFRAME'
  selectedPaymentMethod: string | null
}) => void

export default function CreditCardForm(props: {
  email: string | null
  restaurant: RestaurantInfo
  onSuccess: PaymentSuccessEvent
  checkGuid: string
  orderGuid: string
  paymentAmount: number
}) {
  const sentry = useSentry()
  const isSpiEnabled = Boolean(
    useBanquetProps().featureFlags?.['nv1-spi-enabled']
  )
  const { setPaymentError, setIsCcDataValid, setPaymentLoading } =
    useCreditCardForm()

  React.useEffect(() => {
    // on unmount, reset form context values
    return () => {
      setPaymentError(null)
      setIsCcDataValid(false)
      setPaymentLoading(false)
    }
  }, [])

  if (isSpiEnabled) {
    const email = props.email
    if (email) {
      return <CreditCardFormWithSpi {...props} email={email} />
    } else {
      /** THIS IS AN EXPECTED WARNING UNTIL FORCING EMAIL FOR /payDeposit FLOW ACCOMPLISHED
       * See: https://toasttab.atlassian.net/browse/TTAPP-1789
       */
      sentry.captureMessage(
        'SPI flow is enabled, but an email has not been provided. Falling back to legacy iframe.',
        'warning'
      )
    }
  }
  return <CreditCardFormIframe {...props} />
}
